import {
  GET_UNREAD_MESSAGES_COUNT,
  GET_CURRENT_CONVERSATION,
  GET_CONVERSATION_LIST,
  UPDATE_UNREAD_MESSAGES_COUNT,
  HIDE_CHAT_ROOM,
  PIN_CHAT,
  UNPIN_CHAT,
  MARK_AS_UNREAD,
  MARK_AS_READ,
  CURRENT_CHAT_ROOM_ID,
} from './types';


export default {

  [GET_UNREAD_MESSAGES_COUNT]: (state, count) => {
    state.unreadMessagesCount = count;
  },
  [UPDATE_UNREAD_MESSAGES_COUNT]: (state, count) => {
    state.unreadMessagesCount -= count;
  },
  [GET_CURRENT_CONVERSATION]: (state, { conversation, page }) => {
    if (page === 1) {
      state.currentConversation = conversation.reverse();
    } else {
      state.currentConversation = [...conversation.reverse(), ...state.currentConversation];
    }
  },
  [GET_CONVERSATION_LIST]: (state, { conversations, page }) => {
    if (page === 1) {
      state.chatRooms = [...conversations];
    } else {
      state.chatRooms = [...state.chatRooms, ...conversations];
    }
  },
  [HIDE_CHAT_ROOM]: (state, { chatIds }) => {
    state.chatRooms = state.chatRooms.filter(({ id }) => !chatIds.includes(id));
  },
  [PIN_CHAT]: (state, { chatIds }) => {
    chatIds.forEach((chat) => {
      const index = state.chatRooms.findIndex(({ id }) => id === chat);
      state.chatRooms[index].sorting_point = 1;
      state.chatRooms.unshift(state.chatRooms[index]);
      state.chatRooms.splice(index + 1, 1);
    });
    state.chatRooms = [...state.chatRooms];
  },
  [MARK_AS_UNREAD]: (state, { chatIds }) => {
    chatIds.forEach((chat) => {
      const index = state.chatRooms.findIndex(({ chat_room_id }) => chat_room_id === chat);
      if (state.chatRooms[index].unread_messages_count === 0) {
        state.chatRooms[index].unread_messages_count += 1;
      }
    });
    state.chatRooms = [...state.chatRooms];
  },
  [MARK_AS_READ]: (state, { chatIds }) => {
    chatIds.forEach((chat) => {
      const index = state.chatRooms.findIndex(({ chat_room_id }) => chat_room_id === chat);
      if (state.chatRooms[index].unread_messages_count) {
        state.chatRooms[index].unread_messages_count = 0;
      }
    });
    state.chatRooms = [...state.chatRooms];
  },
  [UNPIN_CHAT]: (state, { chatIds }) => {
    chatIds.forEach((chat) => {
      const index = state.chatRooms.findIndex(({ id }) => id === chat);
      state.chatRooms[index].sorting_point = 0;
      state.chatRooms.push(state.chatRooms[index]);
      state.chatRooms.splice(index, 1);
    });
    state.chatRooms = [...state.chatRooms];
  },
  [CURRENT_CHAT_ROOM_ID]: (state, chatRoomId) => {
    state.currentChatRoomId = chatRoomId;
  },
};
